import React from 'react';
import styles from '../../styles/components/AboutUs.module.css';
import photo1 from '../../assets/nana_cece_family_disney.jpg';
import photo2 from '../../assets/nana_cece_40.jpg';
import photo3 from '../../assets/nana_cece_baby_sister.jpg';

function AboutUs() {
  return (
    <section id="aboutUs" className={styles.aboutUsSection}>
      <div className={styles.photoStack}>
        <div className={`${styles.photo} ${styles.photo1}`} style={{backgroundImage: `url(${photo1})`}}></div>
        <div className={`${styles.photo} ${styles.photo2}`} style={{backgroundImage: `url(${photo2})`}}></div>
        <div className={`${styles.photo} ${styles.photo3}`} style={{backgroundImage: `url(${photo3})`}}></div>
      </div>
      <div className={styles.textContent}>
        <h2>About Us</h2>
        <p>Nana + Cece celebrates family, memories, and magical moments. Named after the nicknames my daughters gave each other, we embrace the busy family lifestyle and highlight activities, products, and events that promote quality time spent together.</p>
      </div>
    </section>
  );
}

export default AboutUs;